import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

const FollowingListPage = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFollowing = async () => {
      try {
        const profileResponse = await api.get(`/users/${username}`);
        const response = await api.get(`/users/${profileResponse.data.id}/following`);
        setFollowing(response.data);
      } catch (error) {
        toast.error("Unable to load following.");
      } finally {
        setLoading(false);
      }
    };
    loadFollowing();
  }, [username]);

  return (
    <div className="space-y-6" data-testid="following-list-page">
      <div>
        <h2 className="text-2xl font-semibold" data-testid="following-list-title">Following</h2>
        <p className="text-sm text-muted-foreground" data-testid="following-list-subtitle">
          People @{username} follows
        </p>
      </div>
      {loading ? (
        <div className="text-sm text-muted-foreground" data-testid="following-list-loading">
          Loading following...
        </div>
      ) : following.length === 0 ? (
        <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="following-list-empty">
          Not following anyone yet.
        </div>
      ) : (
        <div className="space-y-3" data-testid="following-list">
          {following.map((followed) => (
            <button
              key={followed.id}
              type="button"
              className="flex items-center gap-3 text-left"
              onClick={() => navigate(`/user/${followed.username}`)}
              data-testid={`following-list-item-${followed.id}`}
            >
              <img
                src={followed.avatar_url}
                alt={followed.username}
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold">@{followed.username}</div>
                <div className="text-xs text-muted-foreground">{followed.full_name}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FollowingListPage;
